<template>

  <div class="pricing-table info_price">
    <div class="pricing">

      <div class="info_price_summary pricing-table-row">
        <slot></slot>
      </div>
    </div>
  </div>

</template>

<script>
export default {

}
</script>
